
import React from 'react';
import { ItineraryEvent } from '@/types/itinerary';
import { TransportationEmptyState } from './TransportationEmptyState';
import { TransportationTable } from './TransportationTable';
import { useIsMobile } from '@/hooks/use-mobile';
import MobileTransportationCard from './MobileTransportationCard';

interface TravelScheduleTableProps {
  transportationEvents: ItineraryEvent[];
  forSelectedDate?: boolean;
}

const TravelScheduleTable: React.FC<TravelScheduleTableProps> = ({ 
  transportationEvents,
  forSelectedDate
}) => {
  const isMobile = useIsMobile();

  if (transportationEvents.length === 0) {
    return <TransportationEmptyState forSelectedDate={forSelectedDate} />;
  }

  // Sort events by date and time
  const sortedEvents = [...transportationEvents].sort((a, b) => {
    // First compare dates
    const dateComparison = a.date.localeCompare(b.date);
    if (dateComparison !== 0) return dateComparison;
    
    // If dates are same, compare times (if available)
    if (a.time && b.time) {
      return a.time.localeCompare(b.time);
    }
    
    // Put events with times before events without times
    if (a.time) return -1;
    if (b.time) return 1;
    
    return 0;
  });

  // For mobile devices, use card layout
  if (isMobile) {
    return (
      <div className="space-y-3">
        {sortedEvents.map(event => (
          <MobileTransportationCard key={event.id} event={event} />
        ))}
      </div>
    );
  }

  // For desktop, use table layout
  return (
    <div className="rounded-md border">
      <TransportationTable events={sortedEvents} />
    </div>
  );
};

export default TravelScheduleTable;
